/**
 * Limits Config
 */

define(function(require, exports, module) {
    'use strict';

    module.exports = function() {
        var config = {
            waiting: [
                {
                    date: 'waitingdaydepositlimit',
                    availability: 'depositLimitsWaitingAvailability',
                    value: 'waitingdaydepositlimit',
                    period: 'waitingdaydepositlimit'
                },
                {
                    date: 'waitingweekdepositlimit',
                    availability: 'depositLimitsWaitingAvailability',
                    value: 'waitingweekdepositlimit',
                    period: 'waitingweekdepositlimit'
                },
                {
                    date: 'waitingmonthdepositlimit',
                    availability: 'depositLimitsWaitingAvailability',
                    value: 'waitingmonthdepositlimit',
                    period: 'waitingmonthdepositlimit'
                }
            ],
            defaultData: {
                depositLimitsWaitingAvailability: undefined,
                daydepositlimit: 0,
                weekdepositlimit: 0,
                monthdepositlimit: 0,
                waitingdaydepositlimit: undefined,
                waitingweekdepositlimit: undefined,
                waitingmonthdepositlimit: undefined,
                waitingdaydepositlimitdate: undefined,
                waitingweekdepositlimitdate: undefined,
                waitingmonthdepositlimitdate: undefined,
                daydepositlimitperiodstart: undefined,
                weekdepositlimitperiodstart: undefined,
                monthdepositlimitperiodstart: undefined
            }
        };

        return config;
    };
});
